import React from 'react'
import { useVenti } from 'venti'
import Dialog from '@mui/material/Dialog'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import { SiteConfiguration } from '@matech/thebigpos-sdk'
import { isDarkMode } from '@/services/helper'
import { getTheme } from '@/config'
import LayoutRow from '@/components/layout/LayoutRow'
import { Button } from '../Button'

const theme = getTheme()

export type ModalAppErrorProps = {
	visible?: boolean
	siteConfig?: SiteConfiguration | null
}

const ModalAppError = ({
	visible = false,
	siteConfig,
}: ModalAppErrorProps) => {
	const ventiState = useVenti()
	const muiTheme = useTheme()
	const fullScreen = useMediaQuery(muiTheme.breakpoints.down('md'))

	const handleOKPress = () => {
		ventiState.set(theme.storageKeys.failoverModalVisible, false)
	}

	return (
		<Dialog
			maxWidth="sm"
			open={visible}
			aria-labelledby="responsive-dialog-title"
		>
			<div className="flex flex-col items-center px-6 py-8 md:px-10">
				{siteConfig?.logoUrl && (
					<img
						src={
							isDarkMode() && siteConfig?.darkModeLogoUrl
								? siteConfig.darkModeLogoUrl
								: siteConfig?.logoUrl
						}
						alt="Company Logo"
						className="w-64 sm:w-96 py-10"
					/>
				)}
				<div className="font-lg mb-10 text-center text-slate-500 dark:text-white">
					<LayoutRow>
						<p>
							Your loan application has been submitted and is being
							processed.
						</p>
					</LayoutRow>
					<LayoutRow>
						<p>
							Once this is completed, you will receive an email with
							instructions and next steps for your mortgage
							experience.
						</p>
					</LayoutRow>
				</div>
				<Button
					id="ModalConfirmCloseButton"
					text="OK"
					onClick={handleOKPress}
					style={fullScreen ? { width: '90%' } : { width: 290 }}
					variant="outlined"
				/>
			</div>
		</Dialog>
	)
}

export default ModalAppError
